"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SET_PARENTALLY_APPROVED_CLASSIFICATION_QUERY = "\n    mutation SetParentallyApprovedClassification($code: Classification!) {\n      setParentallyApprovedClassification(code: $code)\n    }\n";
exports.default = SET_PARENTALLY_APPROVED_CLASSIFICATION_QUERY;
//# sourceMappingURL=setParentallyApprovedClassification.js.map